import { FLAGS } from '@gozoki/feature-flags'
import { createFileRoute } from '@tanstack/react-router'
import { FeatureRouteGuard } from '~/components/route-guards'
import { ProductManagementPage } from '~/components/routes/product-management/product-management-page'
import { PRODUCT_MANAGEMENT_READ } from '~/components/routes/product-management/product-management-rights'
import { withRoutePermissions } from '~/utils/rbac'
import { productManagementSearchSchema, withTab } from './-search-schema'

export const Route = createFileRoute('/_authenticated/product-management/')({
  staticData: {
    permission: PRODUCT_MANAGEMENT_READ,
  },
  component: ProductManagementRoute,
  validateSearch: productManagementSearchSchema,
})

withRoutePermissions(Route)

function ProductManagementRoute() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <FeatureRouteGuard flag={FLAGS.productManagement}>
      <ProductManagementPage
        tab={tab}
        onTabChange={(next) =>
          void navigate({ replace: true, search: (previous) => withTab(previous, next) })
        }
      />
    </FeatureRouteGuard>
  )
}
